import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Map configuration',
  attributeName: 'mapConfig',
  validationUrl:'live',
  fields: [
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'mapId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Camera Map',
      hasSelect:false,
      helpText: 'Image of the camera map.',
      fileType: ['image/*'],
      className:'col-sm-6',
      canUpdate:false,
      preview:true,
      size:'L'
    },
    {
      attributeName: 'mapBKId',
      type: FormInputTypes.DOWNLOADABLE,
      hasSelect:false,
      label: 'Background Map',
      helpText: 'Image of the background of the camera map.',
      fileType: ['image/*'],
      className:'col-sm-6',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName: 'mapMobileId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile Map',
      hasSelect:false,
      helpText: 'Image of the camera map for mobile.',
      fileType: ['image/*'],
      className:'col-sm-6',
      canUpdate:false,
      size:'L'
    }, 
    {
      attributeName: 'mapMobileBKId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Background Mobile Map',
      helpText: 'Image of the background of the camera map on mobile.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-6',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'icon360',
      type: FormInputTypes.DOWNLOADABLE,
      label: '360 Icon',
      helpText: 'Image of the 360 camera.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName: 'highlight360',
      type: FormInputTypes.DOWNLOADABLE,
      label: '360 Highlight',
      helpText: 'Image of the 360 camera when it´s highlighted.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName: 'selected360',
      type: FormInputTypes.DOWNLOADABLE,
      label: '360 Selected',
      helpText: 'Image of the 360 camera when it´s selected.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName:"sep3",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'mobileIcon360',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile 360 Icon',
      helpText: 'Image of the 360 camera for mobile.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName: 'mobileSelected360',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile 360 Selected',
      helpText: 'Image of the 360 camera for mobile when it´s selected.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'icon180',
      type: FormInputTypes.DOWNLOADABLE,
      label: '180 Icon',
      helpText: 'Image of the 180 camera.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName: 'highlight180',
      type: FormInputTypes.DOWNLOADABLE,
      label: '180 Highlight',
      helpText: 'Image of the 180 camera when it´s highlighted.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName: 'selected180',
      type: FormInputTypes.DOWNLOADABLE,
      label: '180 Selected',
      helpText: 'Image of the 180 camera when it´s selected',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName:"sep5",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'mobileIcon180',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile 180 Icon',
      helpText: 'Image of the 180 camera for mobile.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName: 'mobileSelected180',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile 180 Selected',
      helpText: 'Image of the 180 camera when it´s selected.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName:"sep6",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'iconFlat',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Flat Icon',
      helpText: 'Image of the flat camera.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName: 'highlightFlat',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Flat Highlight',
      helpText: 'Image of the flat camera when it´s highlighted.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName: 'selectedFlat',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Flat Selected',
      helpText: 'Image of the flat camera when it´s selected',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName:"sep7",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'mobileIconFlat',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile Flat Icon',
      helpText: 'Image of the flat camera for mobile.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName: 'mobileSelectedFlat',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile Flat Selected',
      helpText: 'Image of the flat camera when it´s selected.',
      hasSelect:false,
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      size:'L'
    },
    {
      attributeName:"sep6",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'mainMapLabel',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Map Label',
      required: false,
      className:'col-sm-8',
      default:"",
      helpText: 'Set the map label.',
      errorText: '',
    },
  ]
};